import React, { useMemo, useState } from "react";
import { Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import Text from "../../common/typography/text";
import "./OpenOrderImageUpload.css";

export const OPEN_ORDER_IMAGE_ACCEPT = "image/jpeg,image/png,image/webp";
export const OPEN_ORDER_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export const getOpenOrderImageValidationError = (file) => {
  if (!file) return "Choose an image to upload.";
  if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
    return "Open Order image must be a JPEG, PNG, or WebP file.";
  }
  if (!file.size || file.size > OPEN_ORDER_IMAGE_MAX_BYTES) {
    return "Open Order image must be 5 MB or smaller.";
  }
  return "";
};

const OpenOrderImageUpload = ({
  currentFileName = "",
  disabled = false,
  onClear,
  onFileSelect,
  selectedFile = null,
}) => {
  const [validationError, setValidationError] = useState("");
  const displayedFileName = selectedFile?.name || currentFileName;
  const fileList = useMemo(
    () => displayedFileName
      ? [{ name: displayedFileName, status: "done", uid: "open-order-image" }]
      : [],
    [displayedFileName],
  );

  const handleUpload = ({ file, onError, onSuccess }) => {
    const error = getOpenOrderImageValidationError(file);
    if (error) {
      setValidationError(error);
      onError?.(new Error(error));
      return;
    }
    setValidationError("");
    onFileSelect(file);
    onSuccess?.("ok");
  };

  const handleRemove = () => {
    if (!selectedFile) return false;
    setValidationError("");
    onClear();
    return true;
  };

  return (
    <div className="open-order-image-upload">
      <Text variant="tinyText">Product Group Image</Text>
      <Upload
        accept={OPEN_ORDER_IMAGE_ACCEPT}
        customRequest={handleUpload}
        disabled={disabled}
        fileList={fileList}
        maxCount={1}
        multiple={false}
        onRemove={handleRemove}
      >
        <Button disabled={disabled} icon={<UploadOutlined />}>Upload</Button>
      </Upload>
      <Text color="lightText" variant="tinyText">
        Optional. JPEG, PNG, or WebP. Maximum file size 5 MB.
      </Text>
      {validationError ? (
        <Text color="failureColor" variant="tinyText">{validationError}</Text>
      ) : null}
    </div>
  );
};

export default OpenOrderImageUpload;
